import {
  agentProfileEmailSearch,
  custVerifyProfileEmailSearch
} from '../../constants/apiRequest/requestConstants/endpoints';
import { isAgent } from '../../helpers';
import { makeRequest } from '../../helpers/makeApiRequest';

const defaultProfileResponse = {
  first_name: '',
  last_name: '',
  date_of_birth: '',
  phone: '',
  address: {},
  policies: [],
  isDefaultResponse: true
};

export const getUserProfileFromEmail = async (email) => {
  const response = await makeRequest({
    method: 'POST',
    url: isAgent() ? agentProfileEmailSearch : custVerifyProfileEmailSearch,
    payload: { email: email }
  })
  return response?.error ? defaultProfileResponse : response
};
